export function getEMaCServiceWarrantyEligibilityPeriod() {
  return 14
}
